let Carousel      = require('../components/Carousel');
let animateNumber = require('../utility/animateNumber');

class Chronological {
    constructor() {
        this._timeLine    = document.getElementsByClassName('js-time-line')[0];
        this._dateList    = [];
        this._bar         = null;
        this._currentDate = null;

        this._carousel = new Carousel('.js-carousel-chronological', {
            nextListener: () => {
                this._setPast();
            },
            prevListener: () => {
                this._setPast();
            }
        });

        this._createTimeLine();

        this._setPast();
    }

    _createTimeLine() {
        let dateContainer = document.createElement('div');
        let progression   = document.createElement('div');
        this._bar         = document.createElement('div');
        this._currentDate = document.createElement('span');
        let elements      = this._carousel.getElements();

        for (let item of elements) {
            let title      = item.querySelector('h2');
            let date       = document.createElement('span');
            date.innerText = title.innerText;
            date.className = 'time-line-date';

            if (title.hasAttribute('data-chronological-hide')) {
                date.classList.add('d-none');
            }

            date.addEventListener('click', () => {
                this._carousel.setPosition(this._dateList.indexOf(date));
                this._setPast();
            });

            this._dateList.push(date);

            dateContainer.append(date);
        }

        dateContainer.className = 'date-list';
        this._currentDate.innerText = this._dateList[0].innerText;

        this._dateList[0].classList.add('past');

        this._currentDate.className = 'current-date';

        progression.className = 'progression';
        progression.append(this._bar);

        this._timeLine.append(dateContainer);
        this._timeLine.append(progression);
        this._timeLine.append(this._currentDate);
    }

    _setPast() {
        let index  = this._carousel.getIndex();
        let nbDate = this._dateList.length;

        this._bar.setAttribute('data-step', this._dateList[index].innerText);
        this._currentDate.setAttribute('data-step', this._dateList[index].innerText);

        for (let i = 0; i < nbDate; i++) {
            if (i <= index) {
                this._dateList[i].classList.add('past');
            } else {
                this._dateList[i].classList.remove('past');
            }
            this._dateList[i].classList.remove('active');
        }

        this._dateList[index].classList.add('active');
        animateNumber(this._currentDate, parseInt(this._currentDate.innerText), parseInt(this._dateList[index].innerText), 300);
    }
}

module.exports = Chronological;